<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ props: { disabled: disableSubmit } }"
    @cancel="handleCancel"
    cancelText="关闭">
    <efs-md-breed-batch-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></efs-md-breed-batch-form>
  </j-modal>
</template>

<script>

  import EfsMdBreedBatchForm from './EfsMdBreedBatchForm'
  export default {
    name: 'EfsMdBreedBatchModal',
    components: {
      EfsMdBreedBatchForm
    },
    data () {
      return {
        title:'',
        width:1100,
        visible: false,
        disableSubmit: false
      }
    },
    methods: {
      setCompanyCode(){},
      add () {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add();
        })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.handleOk();
        // this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>